// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3qFaG","header":"ReportDetails_header__2xVS4","title":"ReportDetails_title__8K9HQ","left":"ReportDetails_left__3WB0y"};